/**
 * What the screens may say about the live connection: "Jonli" when the socket is open,
 * "Qayta ulanmoqda" while it retries, nothing when it has stopped for good.
 */
import { create } from "zustand";

import type { RealtimeStatus } from "@/lib/realtime";

interface RealtimeStatusState {
  status: RealtimeStatus;
  setStatus: (status: RealtimeStatus) => void;
}

export const useRealtimeStatus = create<RealtimeStatusState>((set) => ({
  status: "idle",
  setStatus: (status): void => {
    set({ status });
  },
}));
